// Make 'timeline availability link' work on mobile 
(function(){
  if(document.body.classList.contains('template-product')){
        let redLead = document.querySelector('.lead-red');
        let mobileDescription = document.querySelector('#tab-description .popup-mobile');
    
        redLead.addEventListener('click', () => {
          if(window.innerWidth > 550){
            return;
          }else{
            mobileDescription.click();
          }
        });
    };
})()

<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  $(document).ready(function(){

		$(window).load(function(){
			$duration = 15;
			$('.seconds').text($duration);
			$('.popup-wrap').fadeIn(1500);

			$myTimer = setInterval(function(){ startTimer() }, 1000);
			$('.popup .btn-close').on("click",function(){
				clearInterval($myTimer);
				$('.popup-wrap').fadeOut(500);
			});
			
			function startTimer(){
				$duration--;
				$('.seconds').text($duration);
				if($duration==0){
					clearInterval($myTimer);
					$('.popup-wrap').fadeOut(500);
				}
			}
		});
	});

$(function() {
  $(".video-link").click(function () {
    var theModal = $(this).data("target"),
        videoSRC = $(this).attr("data-video"),
        videoSRCauto = videoSRC + "?modestbranding=1&rel=0&controls=0&showinfo=0&html5=1&autoplay=1";
    $(theModal + ' iframe').attr('src', videoSRCauto);
    $(theModal + ' button.close').click(function () {
      $(theModal + ' iframe').attr('src', videoSRC);
    });
  });
});

jQuery(document).ready(function(){
	//show hidden images
	if ($(window).width() > 1024) {
      jQuery('.myhover').hover(
          function(){
              jQuery(this).children('div').show();
          },
          function(){
              jQuery(this).children('div').hide();   
          }
      )
    }
  
	// Horizontal scrolling table with Fixed first column
	jQuery(".coll_modular").clone(true).appendTo('.modular_data').addClass('clone'); 

	// CSS superscript registration trademark
  	jQuery("#tabs-information p, h1, .product-details h3, #breadcrumb span, #breadcrumb a, .product-right li").each(function(){
    jQuery(this).html(jQuery(this).html().replace(/&reg;/gi, '<sup>&reg;</sup>').replace(/®/gi, '<sup>&reg;</sup>').replace('<sup><sup>', '<sup>').replace('</sup></sup>', '</sup>'));
   	});
  
  	setTimeout(function(){$(window).trigger('resize');}, 200); 

    var prodtype = jQuery('.productView-info-item .productView-info-value.info-type').text();
    var infotype = prodtype.replace(/\s/g, '');
    if (infotype == 'Stuff'){}
    else{
     var availability = jQuery('.productView-info-item .productView-info-value.info-availability').text();
     if (availability == 'In Stock'){
       jQuery('.productView-info-item .productView-info-value.info-availability').text('See timeline below');
     }
    }

  var prodtype = jQuery('.productView-info-item .productView-info-value.info-type').text();
    var infotype = prodtype.replace(/\s/g, '');
    if (infotype == 'Armor-SoftArmorProtectors'){
        jQuery('.halo-productView-right.productView-details .productView-price').hide();
        jQuery('.halo-productView-right.productView-details .quantity_selector').hide();
        jQuery('.halo-productView-right.productView-details .productView-subtotal').hide();
        jQuery('.halo-productView-right.productView-details .productView-buttons').hide();
    }
});
